import Component from '../component';

export default class NavigationSelect extends Component {
  constructor(element) {
    super(...arguments);

    this.$selectElement = $(element);

    this.baseUrl = this.$selectElement.data('navigation-url');
    this.param = this.$selectElement.data('navigation-param');

    this.setInitialValue();

    this.bindEvents();
  }

  bindEvents() {
    this.$selectElement.on(
      'change.NavigationSelect',
      this.handleSelectChange.bind(this)
    );
  }

  unbindEvents() {
    this.$selectElement.off('change.NavigationSelect');
  }

  setInitialValue() {
    const paramMatcher = new RegExp(`${this.param}=(\w+)`);
    const matchedParam = location.search.match(paramMatcher);

    if (!matchedParam) return;

    this.$selectElement.val(matchedParam[1]);
  }

  handleSelectChange(event) {
    const selectedValue = event.target.value;
    if (!selectedValue) return (window.location = this.baseUrl);

    window.location = `${this.baseUrl}?${this.param}=${selectedValue}`;
  }
}
